/*
 * Module for the topic label modal
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/admin/userAdministration/userDetails/basicUserInfoDisplay/basicUserInfoView",
  "modules/admin/userAdmin/passwordAdmin/passwordAdminModule",
], function (Marionette, $, Messenger, BasicUserInfoView) {
  var BasicUserInfoController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "basicUserInfoModule";
    },
    show: function (user) {
      this.model = user;
      //get the logged in user
      var currentUser = Messenger.reqres.request("user");
      //check whether the user is the logged in user and keep track of that fact on the user model
      this.model.isLoggedInUser = currentUser.get("loginName") === this.model.get("userLogin");

      //trigger an event on the vent notifying listeners that the user is, or is not a tenant admin
      var isTenantAdmin = this.model.isTenantUser() && this.model.get("isAdmin");
      Messenger.vent.trigger("changed:edited:user:tenant:admin", isTenantAdmin);

      user.showPasswordFields = Messenger.reqres.request("tenant:needsPassword");
      this.view = new BasicUserInfoView.basicUserInfoView({ model: user });

      this.view.on(
        "change:enabledStatus",
        function (value) {
          this.model.set("enabledStatus", value);
        },
        this,
      );

      if (this.model.isTenantUser()) {
        this.view.on(
          "toggle:tenant:admin",
          function () {
            this.model.set("isAdmin", !this.model.get("isAdmin"));
            //let the other modules in the userDetailsModal know that the tenant admin status of this user was changed
            Messenger.vent.trigger("changed:edited:user:tenant:admin", this.model.get("isAdmin"));
            this.view.render();
          },
          this,
        );
      } else {
        this.model.set("isAdmin", true);
      }

      this.view.on(
        "set:password",
        function () {
          //make sure that any textboxes we have open can be saved without issue
          if (Messenger.reqres.request("save:textbox")) {
            this.model.set("showPassword", true);
            this.view.render();
            //select the password textbox
            this.view.enableTextbox("#password");
          }
        },
        this,
      );

      this.showRegion(this.view);
    },
    nameError: function (div, errorMessage) {
      this.view.showError(div, errorMessage);
    },
  });

  return BasicUserInfoController;
});
